module.exports = __webpack_public_path__ + "img/price-transparrent.fc335e62.svg";